<template>
  <div>
    <div class="top-text m-4 text-center-small">
      {{ $t('filterTimePeriod') | capitalize }}
    </div>
    <div class="dates-container m-4">
      <div class="pill-container mr-4">
        <div
          v-for="quarter in [1, 2, 3, 4]"
          :key="quarter"
          class="pill"
          :class="{ selected: isSelectedQuarter(quarter) }"
          @click="setQuarter(quarter)"
        >
          {{ `Q${quarter}` }}
        </div>
      </div>

      <div class="pill-container">
        <span
          class="arrow-icon mr-2 pointer"
          @click="yearShift--"
        >
          <i class="fas fa-chevron-left" />
        </span>
        <div
          v-for="year in currentYears"
          :key="year"
          class="pill"
          :class="{ selected: isSelectedYear(year) }"
          @click="setYear(year)"
        >
          {{ year }}
        </div>
        <span
          v-if="yearShift<0"
          class="arrow-icon ml-2 pointer"
          @click="yearShift++"
        >
          <i class="fas fa-chevron-right" />
        </span>
        <span
          v-else
          style="width:8px;"
          class="ml-2"
        />
      </div>
    </div>
    <div class="m-4 link-class-no-pointer text-center-small">
      {{ $t('orSelectCustomDateRange') }}
      <div class="mt-2">
        <DatePicker
          v-model="period"
          :placeholder="$t('select_date_range') | capitalize"
          @change="unsetYearAndQuarters"
          range
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.dates-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media screen and (max-width: 1620px) {
    flex-direction: column;
    align-items: center;
  }
}

.top-text {
  font-size: 22px;
  font-weight: 500;
  margin-top: 40px;
}

.selected {
  opacity: 1;
  background-color: #0091ff !important;
  color: white;
}

.pill-container {
  display: flex;
  margin-top: 8px;
  align-items: center;
}

.pill {
  height: 80px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  cursor: pointer;
  border: 1px solid rgba(224, 219, 219, 0.671);
}

.pill:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.pill:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
</style>

<script>
import { inRange, max, min, pull, range } from "lodash"
import moment from "moment"

export default {
  name: "PeriodSelector",
  data () {
    return {
      period: [],
      yearShift: 0,
      year: null,
      quarterRange: [1 , 1],
    }
  },
  methods: {
    isSelectedYear (year) {
      return this.year === year
    },
    isSelectedQuarter (quarter) {
      return inRange(quarter, min(this.quarterRange), max(this.quarterRange) + 1)
    },
    setYear (year) {
      this.year = year
      this.setDateRange()
    },
    setQuarter (quarter) {
      let quarters = []

      // Set the year to current if it was not set
      this.year = this.year ? this.year : moment().year()

      if (this.isSelectedQuarter(quarter)) {
        quarters = [quarter, quarter]
      } else {
        pull(this.quarterRange, 0) // remove zeros
        quarters = [quarter, ...this.quarterRange]
      }
      // Set quarters. If none is selected, set first quarter
      this.quarterRange = [min(quarters), max(quarters)]
      this.setDateRange()
    },
    unsetYearAndQuarters () {
      this.quarterRange = [0, 0]
      this.year = null
    },
    setDateRange () {
      const startDate = moment(`${ min(this.quarterRange) } ${ this.year }`, "Q YYYY") 
      const endDate = moment(`${ max(this.quarterRange) } ${ this.year }`, "Q YYYY").endOf("quarter")
      this.period = startDate.isValid() && endDate.isValid() ? [startDate.toDate(), endDate.toDate()] : []
    },
  },
  computed: {
    currentYears () {
      const year = moment().year() + this.yearShift
      return range(year - 3, year + 1)
    },
  },
  watch: {
    // Handles internal model changes.
    period (newVal) {
      this.$emit("input", newVal)
    },
    // Handles external model changes.
    value (newVal) {
      this.period = newVal
    }
  },
  props: {
    value: null
  },
  created () {
    if (this.value) {
      // Set inner value from value (a date range array)
      this.unsetYearAndQuarters()
      this.period = this.value
    } else {
      this.year = moment().year()
    }
  }
}
</script>
